// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2FDWs","loaderOuter":"PageOverlayLoader_loaderOuter__CCBCc"};